import { beastStatusAtom, isConnectedToBeastAtom } from '@realtime';
import { atom } from 'jotai';

type Status = 'ready' | 'error' | 'idle' | 'waiting' | 'initializing' | 'processing' | 'unknown';

/**
 * Used for css statuses
 * @todo move this logic outside of atoms in favor of a map
 */
export const uiBeastStatusAtom = atom<Status>((get) => {
    const beast = get(beastStatusAtom);

    switch (beast) {
        case 'BALL_STEADY':
            return 'ready';
        case 'SWING_ANALYSIS_FAILED':
            return 'error';
        case 'IDLE':
            return 'idle';
        case 'INIT':
            return 'initializing';
        case 'ANALYZING_SWING':
            return 'processing';
        case 'LIVE_FEEDBACK_WAITING_FOR_CONFIG':
            return 'waiting';
        case 'LIVE_FEEDBACK_WAITING_FOR_TARE':
            return 'waiting';
        case 'LIVE_FEEDBACK_WAITING_FOR_BALL':
            return 'waiting';
        case 'LIVE_FEEDBACK_WAITING_FOR_P1':
            return 'ready';
        case 'LIVE_FEEDBACK_ACTIVE':
            return 'ready';
        case 'BALLLESS_STEADY':
            return 'ready';
        case 'BALLLESS_WAITING_FOR_P1':
            return 'waiting';
        case 'BALLLESS_SWING_IN_MOTION':
            return 'ready';
        default:
            return 'unknown';
    }
});

/**
 * Used for text status in floor
 * @todo move this logic outside of atoms in favor of a map
 */
export const statusLabelAtom = atom((get) => {
    const status = get(beastStatusAtom);
    // Have connection status of both beast and relay to display „Disconnected“ message if either one disconnects.
    const connected = get(isConnectedToBeastAtom);

    if (!connected) {
        return 'Disconnected';
    }
    switch (status) {
        case 'IDLE':
            return 'Idle';
        case 'INIT':
            return 'Initializing';
        case 'SWING_ANALYSIS_FAILED':
            return 'Analysis failed';
        case 'ANALYZING_SWING':
            return 'Processing';
        case 'LIVE_FEEDBACK_WAITING_FOR_BALL':
            return 'Waiting for ball';
        case 'LIVE_FEEDBACK_WAITING_FOR_TARE':
            return "'Waiting for Start'";
        case 'WAITING_FOR_BALL':
            return 'Waiting for ball';
        case 'LIVE_FEEDBACK_WAITING_FOR_P1':
            return 'Ready for P1';
        case 'LIVE_FEEDBACK_ACTIVE':
            return 'Active';
        case 'LIVE_FEEDBACK_WAITING_FOR_CONFIG':
            return 'Waiting for Config';
        case 'BALL_DETECTED':
            return 'Ball detected';
        case 'BALL_STEADY':
            return 'Ready';
        case 'BALLLESS_WAITING_FOR_P1':
            return 'Waiting for Golfer';
        case 'BALLLESS_STEADY':
            return 'Ready';
        case 'BALLLESS_SWING_IN_MOTION':
            return 'Ready';
        default:
            return 'Unknown';
    }
});
